import React, {FC, ReactNode, useCallback, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import { DEF_PG_SIZE_SUB } from "../../constants/maximum-page-size";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from "../../models/ColumnDefinitions/BiometricColumns";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import searchColumns from '../../models/search/BiometricSearch';
import TableTab from "../tabs/table-tab";
import {
    getBiometricDevices,
} from "../../services/biometricService";
import {getSiteNamesWithPagination} from "../../services/siteService";
import BiometricSearch from "../../models/search/BiometricSearch";
import {removeColumns} from "../../models/utilities/columnHelper";
import { ListData } from "../../models/ListData";
import {appendFilter} from "../../utilities/filters";

interface Props {
    itemId: string,
    children?:ReactNode
}

const PresetBiometric: FC<Props> = ({ itemId, children }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.assignedBiometricDevices);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const history = useHistory();
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    useEffect(() => {
        setLookup([{
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: BiometricSearch.find(item => item.accessor === "site")?.searchOnName,
        }]);
    }, []);

    useEffect(() => {
        dataRefresh((query) => getBiometricDevices(translate, query, itemId));
    }, [itemId])

    const handleOnClick = (id: number) => {
        history.push(`/access-control/hardware/biometric/${id}`);
    };

    const getDataWithFilter = useCallback((listParameters?: ListQuery) => {
        const updatedListParameters = {...listParameters, filters: appendFilter(itemId, 'Biometric Profile', 'bioProfile.id', listParameters?.filters ?? [])};
        return getBiometricDevices(translate, updatedListParameters);
    }, [itemId, translate]);

    return <TableContextProvider
        dataMethod={getDataWithFilter}
        manualDataRefresh={manualDataRefresh}
        tableDescriptor={removeColumns(columns, ['queue', 'templatesReaderVsDB', 'preset'])}
        searchDescriptor={removeColumns(searchColumns, ['device', 'site', 'preset'])}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        maxPageSize={DEF_PG_SIZE_SUB}
        lookup={lookup}>
        <TableTab
            onRowClicked={(rowData) => handleOnClick(rowData.id)}
            title={title}
            selectRows={false} 
            cyName="biometricPresets">{children}</TableTab>
    </TableContextProvider>
};

export default PresetBiometric;
